/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandCashtag} from '../api'

export const useMutationSetBrandCashtag = createReactQueryMutationHook('setBrandCashtag', setBrandCashtag)
